<template>
  <div>
    <div class="row">
      <div class="col-lg-2 col-md-2  col-sm-12">
        <transportation-options
          value="140"
          :allowed-transport-options="allowedTransportOptions"
          @onChange="onOptionChange"
        />
      </div>
      <div v-if="currentAcademicYear" class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider v-slot="{ errors }" name="Desde" rules="required">
          <CustomDatePicker
            v-model="selectedStartDate"
            :label="'Desde:'"
            :disabled="model.readOnlyDate"
            :placeholder="'DD/MM/YYYY'"
            :error="errors[0]"
            :custom-error-msg="
              startDateError
                ? startDateError
                : errors
                ? 'Favor de entrar la fecha Desde.'
                : ''
            "
            :required="'required'"
            class="mb-4"
          />
        </ValidationProvider>
      </div>
      <div v-if="currentAcademicYear" class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider v-slot="{ errors }" name="Hasta" rules="required">
          <CustomDatePicker
            v-model="selectedEndDate"
            :label="'Hasta:'"
            :disabled="model.readOnlyDate"
            :placeholder="'DD/MM/YYYY'"
            :error="errors[0]"
            :custom-error-msg="
              endDateError
                ? endDateError
                : errors
                ? 'Favor de entrar la fecha Hasta.'
                : ''
            "
            :required="'required'"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="Accompany"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedOptionAcompany"
            :options="companyList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Acompañante:'"
            :disabled="transportDisabled"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onChangeAccompanyValue"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-3 col-lg-3 col-sm-12 mb-3">
        <label class="input-label">Millaje:</label>
        <ValidationProvider
          v-slot="{ errors }"
          name="Millaje"
          :rules="{
            IsLowerThan50: true,
            IsDecimalNumber: true,
            required: true,
          }"
        >
          <input
            v-model="model.mileage"
            type="number"
            placeholder="Digite el millaje correspondiente"
            class="form-control"
            :class="{
              'was-Invalidated': model.mileage > 50 || errors[0],
            }"
            min="1"
            max="50"
            :disabled="transportDisabled"
            required
          />
          <span v-if="model.mileage > 50" class="text-danger">
            {{ errorMessage }}
          </span>
          <br
            v-if="
              model.mileage > 50 &&
                model.mileage - Math.floor(model.mileage) !== 0
            "
          />
          <span
            v-if="model.mileage - Math.floor(model.mileage) !== 0"
            class="text-danger"
          >
            {{ decimalErrorMessage }}
          </span>
        </ValidationProvider>
        <span class="mile-title">
          <a
            href="https://www.google.com.pr/maps/dir///%4018.2149317%2c-66.4297906%2c10z?hl=es"
            title="Ir a google maps"
            target="_blank"
          >
            Calcular millaje con Google Maps
          </a>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="Departure"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedOptionDeparture"
            :options="departureList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Partida:'"
            :disabled="transportDisabled || isEducationalService"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onDepartureChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureDirection"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.addressLine1"
            label="Dirección:"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          v-model="model.departure.addressLine2"
          label="Dirección 2:"
          :disabled="transportDisabled || disabledDeparture"
        />
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureMunicipality"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedDepartureMunicipality"
            :options="municipalityList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Municipio:'"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onDepartureMunicipalityChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureZipcode"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.zipCode"
            label="Zipcode:"
            maxlength="5"
            mask-type="Zipcode"
            placeholder="#####"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DepartureEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.state"
            label="Estado:"
            :disabled="transportDisabled || disabledDeparture"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="DeparturePhone"
          rules="required"
        >
          <CustomInput
            v-model="model.departure.phone"
            label="Tel.:"
            :disabled="transportDisabled || disabledDeparture"
            :mask-type="'Phone'"
            placeholder="(787) ###-####"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-2" v-if="isDepartureSchool && isFromAee">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          :value="model.departure.schoolName"
          label="Centro AEE:"
          :disabled="true"
        />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider v-slot="{ errors }" name="place" rules="required">
          <CustomDropDown
            v-model="selectedOptionPlace"
            :options="placeList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Lugar:'"
            :disabled="transportDisabled || isEducationalService"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onPlaceChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeDirection"
          rules="required"
        >
          <CustomInput
            v-model="model.place.addressLine1"
            label="Dirección:"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          v-model="model.place.addressLine2"
          label="Dirección 2:"
          :disabled="transportDisabled || disabledPlace"
        />
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeMunicipality"
          rules="required"
        >
          <CustomDropDown
            v-model="selectedPlaceMunicipality"
            :options="municipalityList"
            :fieldkey="'id'"
            :fieldname="'name'"
            :label="'Municipio:'"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg="errors ? 'Este campo es requerido.' : ''"
            :placeholder="'Seleccione una opción'"
            @input="onPlaceMunicipalityChange"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeZipcode"
          rules="required"
        >
          <CustomInput
            v-model="model.place.zipCode"
            label="Zipcode:"
            maxlength="5"
            mask-type="Zipcode"
            placeholder="#####"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-1 col-lg-1 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placeEstate"
          rules="required"
        >
          <CustomInput
            v-model="model.place.state"
            label="Estado:"
            :disabled="transportDisabled || disabledPlace"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
      <div class="col-md-2 col-lg-2 col-sm-12">
        <ValidationProvider
          v-slot="{ errors }"
          name="placePhone"
          rules="required"
        >
          <CustomInput
            v-model="model.place.phone"
            label="Tel.:"
            :disabled="transportDisabled || disabledPlace"
            :mask-type="'Phone'"
            placeholder="(787) ###-####"
            :error="errors[0]"
            :custom-error-msg.sync="errors[0]"
          />
        </ValidationProvider>
      </div>
    </div>
    <div class="row mt-2" v-if="isPlaceSchool && isFromAee">
      <div class="col-md-2 col-lg-2 col-sm-12">
        <CustomInput
          :value="model.place.schoolName"
          label="Centro AEE:"
          :disabled="true"
        />
      </div>
    </div>
    <div class="col-md-12 col-lg-12 col-sm-12">
      <ValidationProvider
        v-slot="{ errors }"
        name="Justification"
        rules="required"
      >
        <CustomTextArea
          v-model="model.justification"
          :label="'Justificación:'"
          :placeholder="'Escribe algo...'"
          :error="errors[0]"
          :custom-error-msg="
            errors ? 'Favor de escribir la justificación.' : ''
          "
          :rows="5"
          :maxlength="3000"
          :disabled="transportDisabled"
          class="mt-4"
        />
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
// import store from "@/store/index";
import alert from '@/mixin/alert.mixin';
import TransportationOptions from '@/components/pei/service/components/transport-detail/TransportationOptions.vue';
import locationTypes from '@/utils/constants/LocationTypes';
import PeiAnalysisService from '@/utils/constants/pei/peiAnalysisService';

import store from '@/store/index';
import {
  CustomDropDown,
  CustomDatePicker,
  CustomInput,
  CustomTextArea,
} from '@/components/common';

extend('IsLowerThan50', (value) => {
  if (value <= 50 && value > 0) {
    return true;
  }
  return 'El millaje no puede ser mayor de 50. (21078)';
});

extend('IsDecimalNumber', (value) => {
  if (value - Math.floor(value) === 0) {
    return true;
  }
  return 'El millaje debe ser un número entero.';
});

export default {
  mixins: [alert],
  name: 'TransportScholarship',
  props: {
    departureList: {
      type: Array,
      default: () => [],
    },
    placeList: {
      type: Array,
      default: () => [],
    },
    currentAcademicYear: {
      type: Object,
      default: () => ({}),
    },
    transportDisabled: {
      type: Boolean,
      default: () => false,
    },
    disabledDeparture: {
      type: Boolean,
      default: () => false,
    },
    disabledPlace: {
      type: Boolean,
      default: () => false,
    },
    allowedTransportOptions: {
      type: Array,
      default: () => [],
    },
    municipalityList: {
      type: Array,
      default: () => [],
    },
    isFromAee: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => ({
        departureCode: 0,
        placeCode: 0,
        specialEquipmentCode: null,
        acompanyCode: '',
        mileage: 0,
        readOnlyDate: false,
        startDate: '',
        endDate: '',
        peiAnalysisServiceCode: 0,
        justification: '',
        departure: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
        place: {
          addressLine1: '',
          addressLine2: '',
          municipalityId: '',
          phone: '',
          state: '',
          zipCode: '',
        },
      }),
    },
  },
  data() {
    return {
      model: {},
      selectedStartDate: null,
      selectedEndDate: null,
      selectedOptionAcompany: null,
      selectedOptionDeparture: null,
      selectedOptionPlace: null,
      selectedDepartureMunicipality: null,
      selectedPlaceMunicipality: null,
      endDateError: '',
      startDateError: '',
      justification: '',
      errorMessage: 'El millaje no puede ser mayor de 50.',
      decimalErrorMessage: 'El millaje debe ser un número entero.',
      companyList: [
        {
          id: '1',
          name: 'Sí',
        },
        {
          id: '0',
          name: 'No',
        },
      ],
    };
  },
  methods: {
    onOptionChange(item) {
      this.$emit('onTransportTypeChange', item.id);
    },
    onChangeAccompanyValue() {
      this.model.acompanyCode = this.selectedOptionAcompany.id;
    },
    onDepartureMunicipalityChange() {
      this.model.departure.municipalityId = this.selectedDepartureMunicipality?.id;
    },
    onPlaceMunicipalityChange() {
      this.model.place.municipalityId = this.selectedPlaceMunicipality?.id;
    },
    validateStartDate() {
      let result = { error: '', valid: true };
      if (this.selectedStartDate) {
        if (
          this.selectedStartDate <
            new Date(this.currentAcademicYear.fromDate) ||
          this.selectedStartDate > new Date(this.currentAcademicYear.toDate)
        )
          result.error =
            'La fecha Desde debe de estar dentro del año fiscal del PEI';
        if (
          this.selectedEndDate &&
          new Date(this.selectedEndDate) <= new Date(this.selectedStartDate)
        )
          result.error = 'La fecha Desde no puede ser mayor a la fecha Hasta';
      }

      if (result.error) {
        result.valid = false;
        this.selectedStartDate = null;
      }

      return result;
    },
    validateEndDate() {
      let result = { error: '', valid: true };

      if (this.selectedEndDate) {
        if (
          this.selectedEndDate < new Date(this.currentAcademicYear.fromDate) ||
          this.selectedEndDate > new Date(this.currentAcademicYear.toDate)
        )
          result.error =
            'La fecha Hasta debe de estar dentro del año fiscal del PEI';
        if (
          this.selectedStartDate &&
          new Date(this.selectedStartDate) >= new Date(this.selectedEndDate)
        )
          result.error = 'La fecha Desde no puede ser mayor a la fecha Hasta';
      }

      if (result.error) {
        result.valid = false;
        this.selectedEndDate = null;
      }

      return result;
    },
    onDepartureChange() {
      this.model.departureCode = this.selectedOptionDeparture?.id;

      if (this.disabledDeparture) {
        this.model.departure = this.clearDirection();
        this.selectedDepartureMunicipality = null;
      }
    },
    onPlaceChange() {
      this.model.placeCode = this.selectedOptionPlace?.id;

      if (this.disabledPlace) {
        this.model.place = this.clearDirection();
        this.selectedPlaceMunicipality = null;
      }
    },
    clearDirection() {
      return {
        addressLine1: '',
        addressLine2: '',
        municipalityId: '',
        phone: '',
        state: '',
        zipCode: '',
      };
    },
    setMunicipality(municipalityId, municipalityKey) {
      if (this.municipalityList.length === 0) return;

      if (municipalityId && municipalityId > 0)
        this[municipalityKey] = this.municipalityList.find(
          (x) => x.id === municipalityId
        );
    },
  },
  computed: {
    isDepartureSchool() {
      return this.model.departureCode == locationTypes.Escuela;
    },
    isPlaceSchool() {
      return this.model.placeCode == locationTypes.Escuela;
    },
    isEducationalService() {
      return this.model.serviceType == PeiAnalysisService.Educativo;
    },
  },
  watch: {
    selectedStartDate(newValue) {
      const isValid = this.validateStartDate();
      this.model.startDate = newValue;
      this.startDateError = newValue ? isValid.error : this.startDateError;
    },
    selectedEndDate(newValue) {
      const isValid = this.validateEndDate();
      this.model.endDate = newValue;
      this.endDateError = newValue ? isValid.error : this.endDateError;
    },
    'model.departure.municipalityId'(value) {
      this.setMunicipality(value, 'selectedDepartureMunicipality');
    },
    'model.place.municipalityId'(value) {
      this.setMunicipality(value, 'selectedPlaceMunicipality');
    },
    municipalityList(value) {
      if (value && value.length > 0) {
        const depatureMunicipalityId = this.model.departure.municipalityId;
        const placeMunicipalityId = this.model.place.municipalityId;

        if (depatureMunicipalityId > 0)
          this.setMunicipality(
            depatureMunicipalityId,
            'selectedDepartureMunicipality'
          );
        if (placeMunicipalityId > 0)
          this.setMunicipality(
            placeMunicipalityId,
            'selectedPlaceMunicipality'
          );
      }
    },
  },
  created() {
    this.model = this.value;
  },
  async mounted() {
    let transInfo = store.getters.getPeiTransportationInfo;

    if (transInfo.departureCode != null && transInfo.placeCode != null) {
      this.selectedOptionDeparture = this.departureList.find(
        (item) => item.id == transInfo.departureCode
      );
      this.selectedOptionPlace = this.placeList.find(
        (item) => item.id == transInfo.placeCode
      );
      this.selectedOptionAcompany = this.companyList.find(
        (item) => item.id == transInfo.acompanyCode
      );
      this.selectedStartDate = transInfo.startDate;
      this.selectedEndDate = transInfo.endDate;
    } else {
      this.selectedStartDate = transInfo.startDate;
      this.selectedEndDate = transInfo.endDate;
      this.selectedOptionDeparture = this.departureList.find(
        (item) => item.id == locationTypes.Hogar
      );
      this.selectedOptionPlace = this.placeList.find(
        (item) => item.id == locationTypes.Escuela
      );
      this.model.departureCode = this.selectedOptionDeparture.id;
      this.model.placeCode = this.selectedOptionPlace.id;
    }
    this.selectedOptionAcompany = this.companyList.find(
      (x) => x.id == this.model.acompanyCode
    );
  },
  components: {
    ValidationProvider,
    CustomDropDown,
    CustomDatePicker,
    CustomInput,
    TransportationOptions,
    CustomTextArea,
  },
};
</script>

<style scoped>
.mile-title {
  text-align: left;
  text-decoration: underline;
  font: Regular 16px/21px Lato;
  letter-spacing: 0;
  color: #2db782;
  opacity: 1;
}
</style>
